/* @flow */
/*jshint esversion: 6 */
import React, { Component } from "react";
import "../../App.css";
import LangContext from "../../contextProvider/LangContext";
import SumDocsExcel from "./SumDocsExcel";

class PurchaseExcel extends Component {

    static contextType = LangContext;

    getText = (id) => {
        return this.context.get(id) || '[' + id + ']'
    }

    componentDidUpdate() {
        document.title = "Cash On Tab - " + this.getText(22138);
    }

    render() {

        return (<SumDocsExcel
            {...this.props}
            title={this.getText(22138)}
            reportName={"reports/DailySalesExcel.xls"}
            docTypeList={'4,16,17,18'}
        />)
    }

}

export default PurchaseExcel;